
import { defineComponent, ref } from 'vue';

export default defineComponent({
  emits: ['showPopUp', 'setGroupData'],
  setup() {
    const activeName = ref('members');

    return {
      activeName,
    };
  },
});
